// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c_yX","left":"styles_left__2BbJH","desktopActions":"styles_desktopActions__3JHGW","title":"styles_title__3eFAU"};